import React, { useState, useRef, useEffect, useCallback } from 'react';
import '../components/assignRadiologistModal.css';
import { getIcon } from '@ohif/ui';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import radiologistUserApi from '@custom/rtk-apis/radiologistuser/getRadiologistUser';
import { assignRadiologistApi } from '@custom/rtk-apis/radiologistuser/assignRadiologist';
import { AssignRadiologistProps } from '@custom/Utils/constants/interfaces';
import {useTheme} from "../../../ui/src/contextProviders"
import changeReviewStatus from '@custom/rtk-apis/teleradiologist/changeReviewStudyStatus';
import { getPriorityFromString } from '../utils';
// import { getPriorityFromString } from '@custom/Utils/utils';

const AssignRadiologistModal: React.FC<AssignRadiologistProps> = ({ isOpen, onClose, message, isError, patientName, extractedValues, id, onAssignSuccess, modality,tableData }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { result: radiologists } = useSelector((state: RootState) => state.getRadiologistUserResponse);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRadiologists, setSelectedRadiologists] = useState<string[]>([]);
  const selectRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [doctorData, setDoctorData] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const {getCancelledStudiesResponse} = useSelector((state: RootState) => state)
  const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');


  // API call on modal open
  useEffect(() => {
    if (isOpen && modality) {
      setIsLoading(true);
      let obj = { from: "studies", modality: modality }
      dispatch(radiologistUserApi(obj))
        .unwrap()
        .then(response => {
          const reviewList = getCancelledStudiesResponse?.reviewStatusResult?.filter((x)=> x.studyInstanceUID == id )
          const filteredList = response?.result.map((r)=>{
            let temp;
           if(reviewList && reviewList.length == 1 && reviewList[0]?.rejected_radiologist?.length > 0){
              const found = reviewList[0]?.rejected_radiologist?.includes(r._id)
               if(found){
                 r['isDisable'] = true
               }else{
                r['isDisable'] = false
               }
           }
           return r
          })
          setDoctorData(response?.result);
          setIsLoading(false);
        })
        .catch(err => {
          console.error('API Error:', err);
          setIsLoading(false);
        });
    }
  }, [isOpen, dispatch]);

  const handleAssign = async () => {
    let matchItem = {};
    extractedValues.forEach(item => {
      if (item["0020000D"].Value[0] === id) {
        matchItem = item;
      }
    });
    // matchItem["00080090"].Value = [{ "Alphabetic": selectedDoctor?._id }];
    // matchItem["00080090"].Value = [{ "Alphabetic": selectedDoctor?.user_code }];

     // Get the existing Referring Physician Name value
  let existingValue = matchItem["00080090"]?.Value?.[0]?.Alphabetic || "";

  if(matchItem["00080090"]?.Value?.length > 1){
    existingValue = matchItem["00080090"]?.Value.map(item => item?.Alphabetic).join("\\")
  }
  let newPhysician = selectedDoctor?.user_code || "";
  let updatedValue = existingValue ? `${newPhysician}\\${existingValue}` : newPhysician;

  matchItem["00080090"] = { Value: [{ "Alphabetic": updatedValue }] };
    await dispatch(assignRadiologistApi({ studyInstanceUID: id, keyValueData: matchItem })).unwrap().then(()=>{
      handleChangeReviewStatus()
    });
    // @ts-ignore
    onAssignSuccess();
    // setTimeout(() => {
    //   window.location.reload();
    // }, 1000);
  };

  const handleChangeReviewStatus = () => {

    const caseStudyIndex = tableData.row.findIndex(t => t.key === "CaseStudy");
    const priority = tableData?.row[caseStudyIndex]?.content?.props?.children?.props?.children?.length > 0 && tableData.row[caseStudyIndex]?.content?.props?.children?.props?.children[0] || ''

    setIsLoading(true)
    const payload = {
      hospitalId,
      studyInstanceUID:id,
      status:'',
      reason:'',
      radiologistId: selectedDoctor._id,
      action:'ASSIGN',
      priority,
      patientName:tableData?.rawStudyDetails?.patientName,
      UHID: tableData?.rawStudyDetails?.mrn,
      patientId: tableData?.rawStudyDetails?.accession,
      gender: tableData?.rawStudyDetails?.gender,
      patientDob: tableData?.rawStudyDetails?.patientDob
    }

    dispatch(changeReviewStatus(payload)).unwrap().then((res)=>{
      setTimeout(() => {
        window.location.reload()
      }, 1500);
    })

  }
  useEffect(() => {
    if (!isOpen) {
      setSelectedRadiologists([]);
      setIsDropdownOpen(false);
    }
  }, [isOpen]);

  const updateDropdownWidth = useCallback(() => {
    if (selectRef.current && dropdownRef.current) {
      dropdownRef.current.style.width = `${selectRef.current.offsetWidth}px`;
    }
  }, [selectRef.current?.offsetWidth]);

  useEffect(() => {
    updateDropdownWidth();
    window.addEventListener('resize', updateDropdownWidth);

    return () => {
      window.removeEventListener('resize', updateDropdownWidth);
    };
  }, [updateDropdownWidth]);

  const handleSelectClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleRowClick = (doctorId: string,isDisable:boolean) => {
    if(isDisable){
      return
    }
    const selectedDoctor = doctorData.find(doctor => doctor._id === doctorId);
    if (selectedDoctor) {
      setSelectedDoctor(selectedDoctor);
      setSelectedRadiologists(prevSelected => {
        return prevSelected.includes(selectedDoctor.name) ? [] : [selectedDoctor.name];
      });
    }
  };

  const formatSelectedValues = () => {
    const selectedText = selectedRadiologists.length > 0
      ? selectedRadiologists.join(', ')
      : '-Select-';

    return (
      <span className={selectedRadiologists.length > 0 ? 'text-black' : ''}>
        {selectedText}
      </span>
    );
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, selectRef]);

  if (!isOpen) return null;

  const formatAvailability = (days) => {
    // Define the order of days for reference
    const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    // Check if days are in a continuous sequence
    const areDaysConsecutive = days.every((day, index) => {
      const dayIndex = dayOrder.indexOf(day);
      return index === 0 || dayIndex === dayOrder.indexOf(days[index - 1]) + 1;
    });
    console.log(days?.length,"lenhth")

    if (days.length > 2 && areDaysConsecutive) {
      // If days are consecutive, return as "First day - Last day"
      return `${days[0]} - ${days[days.length - 1]}`;
    } else if (days.length > 1) {
      // Otherwise, return as a comma-separated string
      return days.join(', ');
    } else {
      // If there's only one day, return it directly
      return days[0];
    }
  };


  const formatTimeAvailability = (fromTime: string, toTime: string) => {
    // Helper function to convert time string (HH:mm) to 12-hour format with AM/PM
    const convertToAmPm = (time: string) => {
      const [hours, minutes] = time.split(':');
      const date = new Date();
      date.setHours(Number(hours), Number(minutes));
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const fromTimeFormatted = convertToAmPm(fromTime);
    const toTimeFormatted = convertToAmPm(toTime);
    return `${fromTimeFormatted} - ${toTimeFormatted}`;
  };

  const isDarkMode = useTheme();

  return (
    <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center" style={{ zIndex: 9999 }}>
      <div className="modal-container w-[32rem] bg-white p-6 rounded-lg shadow-lg radiologist-popup">
        <div className='modal-header'>
          <h2 className="text-xl font-semibold">Assign Radiologist</h2>
          <button onClick={onClose} className="icon icon-header">
            {getIcon('CrossIcon', { height: '16px', width: '16px' })}
          </button>
        </div>
        <p className="font-semibold">Patient Name: <span className='font-medium'>{patientName}</span></p>
        <label className="block text-md font-medium">Radiologist</label>
        <div className="relative-div">
          <div
            ref={selectRef}
            className="custom-select block w-full border border-border rounded-md p-2 mb-4 cursor-pointer"
            onClick={handleSelectClick}
          >
            {formatSelectedValues()}
          </div>
          {isDropdownOpen && (
            <div
              ref={dropdownRef}
              className="absolute dropdown-container z-10 bg-white border border-border rounded-md max-h-60 overflow-y-auto pb-3"
            >
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2 px-8 text-base font-medium text-left">Doctor's Name</th>
                    <th className="border p-2 px-3 text-base font-medium text-left">Time Slots</th>
                    <th className="border p-2 px-3 text-base font-medium text-left">Availability (Days)</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={3} className="text-center py-2">Loading...</td>
                    </tr>
                  ) : (
                    doctorData?.map((doctor) => {
                      return (
                        <>
                          <tr
                            key={doctor._id}
                            className={`border-b border-gray-400 hover:bg-gray-100 cursor-pointer ${isDarkMode?.isDarkMode ? "text-white" : "text-black"} ${selectedRadiologists.includes(doctor.name) ? 'bg-common-bright text-black' : ''}`}
                            onClick={() => handleRowClick(doctor._id,doctor.isDisable)}
                            style={{background: doctor.isDisable ? '#dc2f2f':""}}
                          >
                            <td className="p-2 px-5 text-sm flex items-center">
                              {selectedRadiologists.includes(doctor.name) && (
                                <span className="check-icon">{getIcon('CheckIcon')}</span>
                              )}
                              <span className='ml-3'>{doctor.name}</span>
                            </td>
                            <td className="p-2 px-7 text-sm items-center" >
                              <span className='ml-3'>{doctor?.fromTimeAvailability && doctor?.toTimeAvailability ? formatTimeAvailability(doctor?.fromTimeAvailability, doctor?.toTimeAvailability) : '--'}</span>
                            </td>
                            <td className="p-2 px-5 text-sm items-center">
                              <span className='ml-3'>{doctor.availabilityDay ? formatAvailability(doctor.availabilityDay) : '--'}</span>
                            </td>
                          </tr>
                        </>
                      )
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className='btn__group'>
          <button className="btn btn__white" onClick={onClose}>Cancel</button>
          <button className="btn btn__primary" onClick={handleAssign}>Assign</button>
        </div>
      </div>
    </div>
  );
};

export default AssignRadiologistModal;
